
<template>
  <v-container>
    <page-title title="post">
      <v-btn icon slot="before">
        <v-icon small color="black">mdi-arrow-left-thick</v-icon>
      </v-btn>
    </page-title>
    {{ post }}
  </v-container>
</template>

<script>
import axios from "axios";
import PageTitle from "../../components/PageTitle.vue";
export default {
  components: { PageTitle },
  data: () => ({
    post: null,
  }),
  created() {
    this.getPostData();
  },
  methods: {
    //get the post and related comments as soon as thr route is reached
    async getPostData() {
      this.postId = postId;
      const { postId } = this.$route.params;
      const postsAndComments = await axios.get("/forum/posts/" + postId);
      //if the post is gotten get the comments too
      this.post = postsAndComments.data.post;
      console.log(postsAndComments.data.post);
    },
  },
};
</script>

<style>
</style>